var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1925 2.87451C6.6725 2.87451 2.1925 7.35451 2.1925 12.8745C2.1925 18.3945 6.6725 22.8745 12.1925 22.8745C17.7125 22.8745 22.1925 18.3945 22.1925 12.8745C22.1925 7.35451 17.7125 2.87451 12.1925 2.87451ZM16.8325 9.67451C16.6825 11.2545 16.0325 15.0945 15.7025 16.8645C15.5625 17.6145 15.2825 17.8645 15.0225 17.8945C14.4425 17.9445 14.0025 17.5145 13.4425 17.1445C12.5625 16.5645 12.0625 16.2045 11.2125 15.6445C10.2225 14.9945 10.8625 14.6345 11.4325 14.0545C11.5825 13.9045 14.1425 11.5745 14.1925 11.3645C14.1995 11.3327 14.1985 11.2997 14.1898 11.2683C14.1811 11.2369 14.1649 11.2082 14.1425 11.1845C14.0825 11.1345 14.0025 11.1545 13.9325 11.1645C13.8425 11.1845 12.4425 12.1145 9.71251 13.9545C9.31251 14.2245 8.9525 14.3645 8.6325 14.3545C8.2725 14.3445 7.5925 14.1545 7.0825 13.9845C6.4525 13.7845 5.9625 13.6745 6.0025 13.3245C6.0225 13.1445 6.27251 12.9645 6.74251 12.7745C9.66251 11.5045 11.6025 10.6645 12.5725 10.2645C15.3525 9.10451 15.9225 8.90451 16.3025 8.90451C16.3825 8.90451 16.5725 8.92451 16.6925 9.02451C16.7925 9.10451 16.8225 9.21451 16.8325 9.29451C16.8225 9.35451 16.8425 9.53451 16.8325 9.67451Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.340c83e1a29a8dc9f37929f7b1bdc74a.svg";
export { ForwardRef as ReactComponent };